import { defineStore } from "pinia";
import config from '@/config'

// Mapeo entre los valores internos del tema (usados por Vuetify/UpdateColors)
// y los que guarda el backend, ligados a la cuenta del usuario.
const THEME_TO_API: Record<string, "light" | "dark"> = {
  ORANGE_THEME: "light",
  DARK_ORANGE_THEME: "dark",
};
const API_TO_THEME: Record<string, string> = {
  light: "ORANGE_THEME",
  dark: "DARK_ORANGE_THEME",
};

export const useCustomizerStore = defineStore({
  id: "customizer",
  state: () => ({
    Sidebar_drawer: config.Sidebar_drawer,
    Customizer_drawer: config.Customizer_drawer,
    Ordersummary_drawer: config.Ordersummary_drawer,
    mini_sidebar: config.mini_sidebar,
    setHorizontalLayout: config.setHorizontalLayout, // Horizontal layout
    actTheme: config.actTheme,
    boxed: config.boxed,
    setBorderCard: config.setBorderCard
  }),

  getters: {
    getActualTheme(state) {
      return state.actTheme;
    }
  },
  actions: {
    SET_SIDEBAR_DRAWER() {
      this.Sidebar_drawer = !this.Sidebar_drawer;
    },
    SET_MINI_SIDEBAR(payload: any) {
      this.mini_sidebar = payload;
    },
    SET_CUSTOMIZER_DRAWER(payload: any) {
      this.Customizer_drawer = payload;
    },
    SET_ORDERSUMMARY_DRAWER(payload: any) {
      this.Ordersummary_drawer = payload;
    },
    SET_LAYOUT(payload: any) {
      this.setHorizontalLayout = payload;
    },
    SET_THEME(payload: any) {
      this.actTheme = payload;
    },
    // Guarda la preferencia de tema en el perfil del usuario (backend),
    // para que viaje entre dispositivos, no solo en este navegador.
    async syncThemePreference() {
      const theme = THEME_TO_API[this.actTheme];
      if (!theme) return;
      try {
        const baseUrl = useRuntimeConfig().public.apiBase;
        await fetchWrapper.post(`${baseUrl}/api/v1/management/theme/`, { theme });
      } catch (e) {
        console.error(e);
      }
    },
    // Carga la preferencia guardada en el backend (llamado al iniciar sesión).
    async loadThemePreference() {
      try {
        const baseUrl = useRuntimeConfig().public.apiBase;
        const response = await fetchWrapper.get(`${baseUrl}/api/v1/management/theme/`);
        const theme = response?.theme && API_TO_THEME[response.theme];
        if (theme) this.actTheme = theme;
      } catch (e) {
        console.error(e);
      }
    },
  },
  persist: {
    storage: persistedState.localStorage,
  },
});
